export const STAFF_PERMISSIONS = Object.freeze([
  "sell",
  "history",
  "inventory",
  "debts",
  "expenses",
  "analytics",
  "assistant",
  "notifications",
  "staff_access",
  "branch_management",
  "settings",
  "billing",
]);

const allowedPermissions = new Set(STAFF_PERMISSIONS);

export function normalizePermissions(role, permissions = []) {
  if (role === "Owner") return [...STAFF_PERMISSIONS];

  const candidates = Array.isArray(permissions) ? permissions : [];
  return Array.from(new Set(candidates)).filter((permission) => allowedPermissions.has(permission));
}

export function hasPermission(session, permission) {
  if (!permission) return true;
  return normalizePermissions(session?.role, session?.permissions).includes(permission);
}

export function hasRole(session, role) {
  return !role || session?.role === role;
}

export function canAccessWorkspaceRoute(session, { permission, role } = {}) {
  return hasRole(session, role) && hasPermission(session, permission);
}

export function getDefaultWorkspaceRoute(session) {
  const destinations = [
    ["analytics", "/dashboard"],
    ["sell", "/sell"],
    ["inventory", "/inventory"],
    ["history", "/history"],
    ["debts", "/debts"],
    ["expenses", "/expenses"],
    ["assistant", "/assistant"],
    ["notifications", "/notifications"],
    ["staff_access", "/staff"],
    ["branch_management", "/branches"],
    ["settings", "/settings"],
    ["billing", "/subscription"],
  ];

  return destinations.find(([permission]) => hasPermission(session, permission))?.[1] || "/tutorials";
}
